import type { CSSProperties, PropsWithChildren } from "react";

const buttonStyles = (textColor: string, backgroundColor: string): CSSProperties => ({
  display: "block",
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "20px",
  padding: "8px 20px",
  borderRadius: "4px",
  backgroundColor,
  marginTop: "8px",
  color: textColor,
  border: `1px solid ${backgroundColor}`,
  textAlign: "center",
  textDecoration: "none",
  textTransform: "uppercase",
  transition: "all ease-in-out 200ms",
  cursor: "pointer",
  // backgroundColor: "var(--litesite-custom-button-background, var(--litesite-primary))",
  // color: "var(--litesite-custom-button-text, var(--litesite-neutral-0))",
  // border: "0.0625rem solid var(--litesite-custom-button-background, var(--litesite-primary))",
});

const disabledButtonStyles: CSSProperties = {
  ...buttonStyles,
  backgroundColor: "#848C8F",
  borderColor: "#848C8F",
  cursor: "default",
};

interface Props extends PropsWithChildren {
  disabled: boolean;
  href: string;
  buttonTextColor: string;
  buttonBackgroundColor: string;
}

export function Button({ disabled, href, children, buttonTextColor, buttonBackgroundColor }: Props) {
  return (
    <a href={href} style={disabled ? disabledButtonStyles : buttonStyles(buttonTextColor, buttonBackgroundColor)}>
      {children}
    </a>
  );
}
